
// Compact, always-visible crisis resource — designed for sidebars and mobile menus.
// Replaces the old auto-triggered full-screen CrisisCard, which broke immersion when
// fictional dialogue tripped the keyword detector. This stays passively present so
// real users in real distress always have a path, without interrupting story flow.
//
// It only ever renders inside the three themed sidebars (RP, DMs, channels),
// so its text takes the theme's inks. It used to be literal creams (#c4b99a,
// #e8d5b0) chosen for the dark themes, which on porcelain put the 988 number
// in ivory on ivory. Of everything in the app, this must never be the thing
// someone cannot read. The literals stay on as fallbacks.
export default function CrisisResourcePanel({ compact = false, style = {} }) {
  return (
    <div
      role="complementary"
      aria-label="Crisis support resources"
      style={{
        background: 'var(--ds-gold-a0f, rgba(196,168,130,0.05))',
        border: '1px solid var(--ds-gold-a33, rgba(196,168,130,0.18))',
        borderRadius: '10px',
        padding: compact ? '10px 12px' : '12px 14px',
        margin: compact ? '8px' : '10px',
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        ...style,
      }}
    >
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '6px',
        fontFamily: "'Cinzel', serif",
        fontSize: '10px',
        letterSpacing: '1.2px',
        color: 'var(--ds-ink-low, #8a7a65)',
        textTransform: 'uppercase',
      }}>
        <span aria-hidden="true">💙</span>
        <span>Need Support?</span>
      </div>

      <div style={{
        fontSize: '12px',
        lineHeight: 1.5,
        color: 'var(--ds-ink, #c4b99a)',
      }}>
        <div style={{ marginBottom: '4px' }}>
          Call or text{' '}
          <a
            href="tel:988"
            style={{ color: 'var(--ds-ink-hi, #e8d5b0)', fontWeight: 700, textDecoration: 'none', letterSpacing: '0.5px' }}
          >988</a>
        </div>
        <div style={{ marginBottom: '6px' }}>
          Text{' '}
          <a
            href="sms:741741?body=HOME"
            style={{ color: 'var(--ds-ink-hi, #e8d5b0)', fontWeight: 700, textDecoration: 'none' }}
          >HOME</a>
          {' '}to{' '}
          <a
            href="sms:741741?body=HOME"
            style={{ color: 'var(--ds-ink-hi, #e8d5b0)', fontWeight: 700, textDecoration: 'none' }}
          >741741</a>
        </div>
        <a
          href="/safety"
          target="_blank"
          rel="noopener"
          style={{
            display: 'inline-block',
            fontSize: '10px',
            color: 'var(--ds-ink-low, #c4a882)',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            letterSpacing: '0.5px',
          }}
        >
          All resources →
        </a>
      </div>
    </div>
  );
}
